<template>
	<div>
		<p v-if="withInfoText">
			Zum Beispiel BMD, SAP FI, Adobe Premiere, Java, AutoCad.<br/>
			Jede Software, die du beherrscht kann wichtig für deinen Beruf sein - z.B. Programme für Grafik,
			Programmierung, Buchhaltung, Musikbearbeitung, Konstruktion, Design, Produktion, Logistik.
		</p>
		<SkillsEdit
			:value="value"
			none-text="Ich beherrsche keine weitere Software"
			self-assessment-placeholder="- Wie gut kannst du das? -"
			meta-skill-property="skillSoftwareSpecial"
			keyword-placeholder="Software, Programme eintragen..."
			keyword-placeholder-further="Weitere Software eintragen..."
			@hasItems="$emit('hasItems', $event)"
			@validChange="$emit('validChange', $event)"
			@input="$emit('input', $event)"
		/>
	</div>
</template>

<script>
import SkillsEdit from "@/vue/common/skill/Edit"
import {mapState} from "vuex";

export default {

	components: {
		SkillsEdit,
	},

	props: {
		value: {
			type: Array,
			required: false,
		},
		withInfoText: {
			type: Boolean,
			required: false,
			default: false,
		}
	},

	computed: {
		...mapState('meta', ['meta']),
	}
}
</script>
